export default __webpack_public_path__ + "static/media/ic_british_columbia.6d78e0ee.svg";